import { useQueryClient } from '@tanstack/react-query'
import { USER_KEYS } from 'hooks/user'

const useCheckCanary = (canaryUsers = [], flag = false) => {
  const queryClient = useQueryClient()
  const { id: userId } =
    queryClient.getQueryData({
      queryKey: [USER_KEYS.GET_USER],
    }) || {}
  return canaryUsers.includes(userId) || flag
}

export default useCheckCanary
